import { ConnectorPin } from "./CablePin";
import { MFG } from "./MFG";

export class Connector {
  public constructor() {
    this.ConnectorPN = "";
    this.MFGRowPointer = "";
    this.MotorDependent = false;
    this.Motor = "";
    this.RowPointer = "";
    this.Manufacturer = new MFG();
    this.Pins = [];
    this.CableType = "";
  }

  public ConnectorPN: string;
  public MFGRowPointer: string;
  public MotorDependent: boolean;
  public Motor: string;
  public RowPointer: string;
  public Manufacturer: MFG;
  public Pins: ConnectorPin[];
  public CableType: string;
}
